module.exports = __webpack_public_path__ + "static/cemio-b1a013dd4cb6c18f55401ce757da647a.png";